import { GroupAnalysisType } from '@/generated/types/navigator/types.gen';

export const ANALYSIS_URL_PARAM = 'analysis';
export const DEFAULT_ANALYSIS = GroupAnalysisType.ENCROACHMENT;

const GROUP_ANALYSIS_TYPES: readonly string[] =
  Object.values(GroupAnalysisType);

const isGroupAnalysisType = (value: string): value is GroupAnalysisType =>
  GROUP_ANALYSIS_TYPES.includes(value);

export const parseAnalysisParam = (searchString: string): GroupAnalysisType => {
  const value = new URLSearchParams(searchString).get(ANALYSIS_URL_PARAM);
  return value !== null && isGroupAnalysisType(value)
    ? value
    : DEFAULT_ANALYSIS;
};

export const analysisParamValue = (
  analysis: GroupAnalysisType
): string | null => (analysis === DEFAULT_ANALYSIS ? null : analysis);

export const applyAnalysisParam = (
  params: URLSearchParams,
  analysis: GroupAnalysisType
): URLSearchParams => {
  const value = analysisParamValue(analysis);
  if (value === null) {
    params.delete(ANALYSIS_URL_PARAM);
  } else {
    params.set(ANALYSIS_URL_PARAM, value);
  }
  return params;
};
